<app-errorlist></app-errorlist>
<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{
        "components.general-information.examination-not-possible" | translate
        }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-examination-not-possible />
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.room-examination.free-text" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-form-field appearance="fill">
      <mat-label>{{
        "components.usage-space.free-text" | translate
        }}</mat-label>
      <textarea id="notes-textarea" aria-label="Free text notes" [ngModel]="leadTaskService.getNotes()" (ngModelChange)="generalInformationService.setNotes($event)"
        matInput rows="3" #notes></textarea>
      <mat-hint align="end">{{ notes.value.length }}/200</mat-hint>
    </mat-form-field>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.general-information.playback-devices.title" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field style="display: block">
      <mat-label>
        {{ "components.general-information.playback-devices.location-label" | translate }}
      </mat-label>
      <mat-select #locationSelect [ngModel]="leadTaskService.getPlaybackDevicesLocation()" (selectionChange)="generalInformationService.setPlaybackDevicesLocation(
                               locationSelect.value)">
        @for (option of playbackDeviceLocations; track $index) {
        <mat-option [value]="option">
          {{ "enums.playbackDeviceLocation." + option | translate }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.general-information.guests.title" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-checkbox [ngModel]="leadTaskService.getGuestsPresent()" (change)="generalInformationService.setGuestsPresent(
                 !leadTaskService.getGuestsPresent())">
      {{ "components.general-information.guests.present-label" | translate }}
    </mat-checkbox>

    @if (leadTaskService.getGuestsPresent()) {
    <mat-form-field style="display: block">
      <mat-label id="guest-count-label">
        {{ "components.general-information.guests.count-label" | translate }}
      </mat-label>
      <input matInput id="guest-count-input" aria-labelledby="guest-count-label" type="number" [attr.min]="1"
        [attr.step]="1" [ngModel]="leadTaskService.getGuestCount()" (ngModelChange)="generalInformationService.setGuestCount(
                             Number.isInteger($event) && $event > 0 ? $event : null)" />
    </mat-form-field>
    }
  </mat-expansion-panel>
  <mat-expansion-panel #photoPanel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.room-examination.pictures" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-upload-pictures [isActive]="photoPanel.expanded"></app-upload-pictures>
  </mat-expansion-panel>
</mat-accordion>